'use strict';

import * as Props from '../Props';

const angular = require('angular');

const LineProperties = {
    Style: {
        'style-group': {
            type: 'style-group',
            members: {
                'font-color': {
                    type: 'color-picker',
                    title: 'line.color',
                    selectedValue: '#ccc',
                    icon: 'fa fa-font'
                }
            }
        },
        'Name': {
            selectedValue: 'style',
            hidden: true
        }
    },
    Margin: angular.copy(Props.marginObject)
};

export default LineProperties;


// WEBPACK FOOTER //
// ./client/app/localStorage/Controls/Line.ts